export default "__VITE_ASSET__Qivm$apM__";